import React from "react";
const StepProgressBar = ({ step = 1, totalSteps = 4 }) => {
  return (
    <div className="d-flex align-items-center justify-content-center gap-0" style={{ width: "100%", maxWidth: "400px", margin: "auto" }}>
      {Array.from({ length: totalSteps }, (_, i) => {
        const current = i + 1;
        const isActive = current <= step;
        return (
          <React.Fragment key={current}>
            {/* Círculo */}
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                width: 36,
                height: 36,
                borderRadius: "50%",
                backgroundColor: current <= step ? "#24304A" : "#E8EAF0",
                color: current <= step ? "#fff" : "#AEB4C0",
                fontWeight: "bold",
                zIndex: 2,
              }}
            >
              {current}
            </div>

            {/* Línea de conexión (salvo después del último) */}
            {current < totalSteps && (
              <div
                style={{
                  flex: 1,
                  height: "4px",
                  backgroundColor: current < step ? "#24304A" : "#E8EAF0",
                  margin: "0 4px",
                }}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default StepProgressBar;